import { render, staticRenderFns } from "./Berekening.vue?vue&type=template&id=d51d2176&"
import script from "./Berekening.vue?vue&type=script&lang=js&"
export * from "./Berekening.vue?vue&type=script&lang=js&"
import style0 from "./Berekening.vue?vue&type=style&index=0&id=d51d2176&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports